export default "__VITE_ASSET__u21hccsz__"